import { render, staticRenderFns } from "./grabbing.vue?vue&type=template&id=69188758&scoped=true&"
import script from "./grabbing.vue?vue&type=script&lang=js&"
export * from "./grabbing.vue?vue&type=script&lang=js&"
import style0 from "./grabbing.vue?vue&type=style&index=0&id=69188758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69188758",
  null
  
)

export default component.exports